/** @format */

const { Fragment, memo } = require("react");
const { Container, Row, Col, Card, Image, Badge } = require("react-bootstrap");

const Hired = memo(() => {
  const tableData = [
    {
      name: "Tiger Nixon",
      position: "System Architect",
      office: "Edinburgh",
      age: "61",
      startdate: "2011/04/25",
      salary: "$320,800",
    },
    {
      name: "Garrett Winters",
      position: "Accountant",
      office: "Tokyo",
      age: "63",
      startdate: "2011/07/25",
      salary: "$170,750",
    },
    {
      name: "Ashton Cox",
      position: "Junior Technical Author",
      office: "San Francisco",
      age: "66",
      startdate: "2009/01/12",
      salary: "$86,000",
    },
  ];

  return (
    <Fragment>
      <Card>
        <Card.Body className="">
          <div className="table-responsive rounded">
            <table className="table table-striped">
              <tbody>
                {tableData.map((item, index) => {
                  return (
                    <tr key={index} className="border-0">
                      <td className="border-0">
                        <Image
                          src=""
                          className="img-fluid avatar-40 rounded-circle"
                          alt="img"
                        />
                      </td>
                      <td className="border-0">
                        <h5 className="mb-1">
                          {item.name}{" "}
                          <Badge bg="success" className="mt-2">
                            HIRED
                          </Badge>
                        </h5>
                        <h6 className="text-secondary">Experience</h6>
                        {item.position}
                      </td>
                      <td className="border-0">
                        <h6 className="text-secondary">Expected Salary</h6>
                        {item.salary}
                      </td>
                      <td className="border-0">
                        <h6 className="text-secondary">Applied Date</h6>
                        {item.startdate}
                      </td>
                      <td className="border-0">
                        <div className="d-flex flex-column">
                          <button className="btn btn-success mb-2">
                            Shortlisted
                          </button>
                          <button className="btn btn-secondary">
                            Rejected
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot></tfoot>
            </table>
          </div>
        </Card.Body>
      </Card>
    </Fragment>
  );
});

export default Hired;
